import React from 'react';
import { StyledThankYouContent } from './StyledThankYouContent';
import { useLocation,useHistory } from 'react-router-dom';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const ThankYouContent = ({title,paragraph, noCta} ) => {

  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }
  return (
    <React.Fragment>
      {
       
          <StyledThankYouContent>
            <div className="page--content">
              <div className="thank-you-result">
                <div className="thankyou-check">
                  <img src={require('../../assets/check.svg')} />
                </div>
                <h6 className="md--title" >{title}</h6>
                <p className="preset-11">{paragraph}</p>
                
                {
                  !noCta &&
                  <div className="cta--primary cursor-cta" onClick={()=> handleCLick('/products/3d-commerce')}>
                    <p className="preset-10 cursor-cta" style={{color: '#45B865'}} >Discover more about 3D commerce</p>
                      <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={'#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        <path className="cursor-cta" d="M13 6H1" stroke={'#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                  </div>
                }
              </div>
            </div>
            
          </StyledThankYouContent>
          
      }
    </React.Fragment>
  );
};



export default ThankYouContent;
